<script setup lang="ts">
/**
 * **展示行**：高度自定，内容完全由宿主通过 `#row-display` 渲染。
 *
 * 库不知道「调试查看器」「组件预览」是什么 —— 那是集成方的领域知识。
 */
import type { DisplayRow } from '../../types/node'

const props = defineProps<{ row: DisplayRow; inGroup: boolean }>()
</script>

<template>
  <div
    class="np-row np-row--display"
    data-row-kind="display"
    :class="{ 'np-row--in-group': props.inGroup }"
    :style="props.row.height ? { height: `${props.row.height}px` } : undefined"
  >
    <slot name="row-display" :row="props.row">
      <span class="np-row__display-fallback">
        {{ props.row.label ?? props.row.render ?? 'display' }}
      </span>
    </slot>
  </div>
</template>
